import { Spacer, TabsBarLink } from '@porsche-code/kado-ui';
import { PHeading, PTabsBar } from '@porsche-design-system/components-react';
import {
  createFileRoute,
  Navigate,
  Outlet,
  useMatchRoute,
} from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';

import { RouteGuard } from '@/components';
import { useAbilityContext } from '@/context';

export const Route = createFileRoute('/support')({
  component: () => {
    const matchRoute = useMatchRoute();

    return (
      <RouteGuard can="read" a="SupportRequest">
        {matchRoute({ to: '/support' }) ? (
          <Navigate to="/support/requests" replace />
        ) : (
          <Support />
        )}
      </RouteGuard>
    );
  },
  beforeLoad: () => {
    return {
      breadcrumb: () => <Trans i18nKey="supportRequest.headline" />,
    };
  },
});

export const Support = () => {
  const { t } = useTranslation();
  const matchRoute = useMatchRoute();
  const { state: ability } = useAbilityContext();

  const tabs: {
    routeId: '/support/requests' | '/support/user-feedbacks';
    label: string;
  }[] = [
    {
      routeId: '/support/requests',
      label: t('supportRequest.requests'),
    },
    {
      routeId: '/support/user-feedbacks',
      label: t('userFeedback.headline'),
    },
  ];

  const activeTabIndex = tabs.findIndex((tab) =>
    matchRoute({ to: tab.routeId, fuzzy: true }),
  );

  return (
    <>
      <PHeading size="lg" aria-level={1} tag="h1">
        {t('supportRequest.headline')}
      </PHeading>
      <Spacer mb="md" />
      {ability.can('manage', 'UserFeedback') && (
        <PTabsBar size="medium" compact activeTabIndex={activeTabIndex}>
          {tabs.map((tab) => (
            <TabsBarLink key={`${tab.routeId}`} to={tab.routeId}>
              {tab.label}
            </TabsBarLink>
          ))}
        </PTabsBar>
      )}
      <Spacer mb="lg" />
      <Outlet />
    </>
  );
};
